import { GET_PX_QUESTIONS_SUCCESS, PUT_PX_QUESTIONS_SUCCESS } from 'stash/actions/api';

const px_questions = (state = {}, action) => {
	switch (action.type) {
		case GET_PX_QUESTIONS_SUCCESS: {
			return {
				...state,
				[action.pxQuestionType]: {
					...action.response.question,
				},
			};
		}
		case PUT_PX_QUESTIONS_SUCCESS: {
			return {
				...state,
				[action.pxQuestionType]: {
					...state[action.pxQuestionType],
					...action.request.body,
				},
			};
		}

		default:
			return state;
	}
};

export default px_questions;
